import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Languages } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  const content = {
    en: {
      navLinks: [
        { name: "Home", href: "/" },
        { name: "About", href: "/about" },
        { name: "Services", href: "/services" },
        { name: "Careers", href: "/career" },
        { name: "Contact", href: "/contact" },
      ],
    },
    zh: {
      navLinks: [
        { name: "首页", href: "/" },
        { name: "关于", href: "/about" },
        { name: "服务", href: "/services" },
        { name: "职业", href: "/career" },
        { name: "联系", href: "/contact" },
      ],
    },
  };

  const current = content[lang];

  return (
    <header className="fixed top-0 w-full z-[100] bg-white border-b border-[#eee]">

      {/* ================= TOP HEADER ================= */}
      <div className="hidden md:block bg-[#1A1A1A] border-b border-[#2a2a2a]">
        <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center text-[13px] text-[#F5F0E8]">

          {/* LEFT */}
          <div className="flex items-center gap-6">

            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-[#2a2a2a] flex items-center justify-center">
                <i className="fa-solid fa-phone text-[14px]"></i>
              </div>
              <span>(+65) 9686 1689</span>
            </div>

            <span className="text-[#444]">|</span>

            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-[#2a2a2a] flex items-center justify-center">
                <i className="fa-regular fa-envelope text-[14px]"></i>
              </div>
              <span>juanna@rigors.com.sg</span>
            </div>

          </div>

          {/* RIGHT */}
          <div className="flex items-center gap-4">

            <a href="#" className="w-8 h-8 rounded-full bg-[#2a2a2a] flex items-center justify-center hover:bg-[#B08D57] transition">
              <i className="fa-brands fa-facebook-f text-[13px]"></i>
            </a>

            <a href="#" className="w-8 h-8 rounded-full bg-[#2a2a2a] flex items-center justify-center hover:bg-[#B08D57] transition">
              <i className="fa-brands fa-twitter text-[13px]"></i>
            </a>

            <a href="#" className="w-8 h-8 rounded-full bg-[#2a2a2a] flex items-center justify-center hover:bg-[#B08D57] transition">
              <i className="fa-brands fa-instagram text-[13px]"></i>
            </a>

            <a href="#" className="w-8 h-8 rounded-full bg-[#2a2a2a] flex items-center justify-center hover:bg-[#B08D57] transition">
              <i className="fa-brands fa-linkedin-in text-[13px]"></i>
            </a>

          </div>

        </div>
      </div>

      {/* ================= MAIN NAV ================= */}
      <nav className="py-4">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">

          <Link to="/" className="flex items-center gap-2">
            <img src="/logo.png" className="h-9" />
            <span className="text-[18px] font-serif tracking-wide text-[#1A1A1A]">
              RIGORS <span className="text-[#B08D57]">LLP</span>
            </span>
          </Link>

          <ul className="hidden lg:flex items-center gap-10 text-[16px] font-sans">
            {current.navLinks.map((link) => {
              const isActive = location.pathname === link.href;

              return (
                <li key={link.name} className="relative group">
                  <Link
                    to={link.href}
                    className={`transition ${
                      isActive
                        ? "text-[#B08D57]"
                        : "text-[#1A1A1A] hover:text-[#B08D57]"
                    }`}
                  >
                    {link.name}
                  </Link>

                  <span
                    className={`absolute left-0 -bottom-1 h-[1px] bg-[#B08D57] transition-all duration-300 ${
                      isActive ? "w-full" : "w-0 group-hover:w-full"
                    }`}
                  ></span>
                </li>
              );
            })}
          </ul>

          <div className="flex items-center gap-6">

            <button
              onClick={() => setLang(lang === "en" ? "zh" : "en")}
              className="text-[#999999] hover:text-[#B08D57] transition"
            >
              <Languages size={18} />
            </button>

          <Link
  to="/contact"
  className="hidden md:inline-block text-[14px] text-[#1A1A1A] hover:text-[#B08D57] transition"
>
  {lang === "en" ? "Get in Touch →" : "联系我们 →"}
</Link>

            <button className="lg:hidden" onClick={() => setIsMenuOpen(true)}>
              <Menu size={24} />
            </button>

          </div>

        </div>
      </nav>

      {/* MOBILE MENU */}
      <div
        className={`fixed top-0 left-0 h-full w-[260px] bg-white z-[200]
        transform transition-transform duration-500
        ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex justify-between items-center px-6 py-6 border-b border-[#eee]">
          <span className="font-serif text-[#1A1A1A] text-lg">
            RIGORS <span className="text-[#B08D57]">LLP</span>
          </span>
          <button onClick={() => setIsMenuOpen(false)}>
            <X size={22} />
          </button>
        </div>

        <ul className="flex flex-col gap-6 px-6 py-8 text-[15px] font-sans">
          {current.navLinks.map((link) => {
            const isActive = location.pathname === link.href;

            return (
              <li key={link.name}>
                <Link
                  to={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`${
                    isActive
                      ? "text-[#B08D57]"
                      : "text-[#1A1A1A] hover:text-[#B08D57]"
                  }`}
                >
                  {link.name}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="px-6 pt-4">
         <Link
  to="/contact"
  onClick={() => setIsMenuOpen(false)}
  className="text-[#B08D57] text-[14px]"
>
  {lang === "en" ? "Get in Touch →" : "联系我们 →"}
</Link>
        </div>
      </div>

      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-[150]"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;